<div class="app-info">
  <section class="app-info__system">
    <h3 class="app-info__section-title">Systeeminformatie</h3>

    <div class="app-info__row app-info__row--alt">
      <span class="app-info__label">
        <span class="app-info__dot app-info__dot--accent"></span>Versie
      </span>
      <span class="app-info__lead"></span>
      <span class="app-info__value app-info__value--mono">{{ appService.version }}</span>
    </div>

    <div class="app-info__row app-info__row--wide">
      <span class="app-info__label">
        <span class="app-info__dot"></span>User Agent
      </span>
      <span class="app-info__value app-info__value--muted app-info__value--wrap">{{
        userAgent
      }}</span>
    </div>

    <div class="app-info__row app-info__row--alt">
      <span class="app-info__label">
        <span class="app-info__dot"></span>Resolutie
      </span>
      <span class="app-info__lead"></span>
      <span class="app-info__value app-info__value--mono">{{ resolution }}</span>
    </div>

    <div class="app-info__row">
      <span class="app-info__label">
        <span class="app-info__dot"></span>Viewport
      </span>
      <span class="app-info__lead"></span>
      <span class="app-info__value app-info__value--mono">{{ viewport }}</span>
    </div>
  </section>

  <div class="app-info__divider"></div>

  <footer class="app-info__footer">
    <div class="app-info__restart-info">
      <span class="app-info__restart-icon"><i eIcon icon="redo"></i></span>
      <span class="app-info__restart-text">
        <span class="app-info__restart-title">Volledig herstarten</span>
        <span class="app-info__restart-desc">
          Herstart de applicatie volledig en wist alle gecachte data.
        </span>
      </span>
    </div>
    <button type="button" class="app-info__restart-btn" (click)="restart()">
      <i eIcon icon="redo"></i>
      <!-- Phone: kort label zodat tekst en knop naast elkaar passen (CSS wisselt). -->
      <span class="app-info__restart-btn-label--full">Herstarten &amp; Cache wissen</span>
      <span class="app-info__restart-btn-label--short">Herstarten</span>
    </button>
  </footer>
</div>
